webpackJsonp([57],{

/***/ "J3iv":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionCreditInfo = (function () {
    function SubscriptionCreditInfo() {
    }
    return SubscriptionCreditInfo;
}());
angular.module('animatronApp.SubscriptionCreditInfo', [])
    .component('subscriptionCreditInfo', {
    bindings: {
        planName: '<',
        period: '<',
        price: '<',
        annualDiscount: '<',
        percentsDiscount: '<',
        amountDiscount: '<',
        credit: '<'
    },
    controller: SubscriptionCreditInfo,
    templateUrl: __webpack_require__("S3/Z")
});


/***/ }),

/***/ "S3/Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-credit-info_8fa080abc1ff2aef08373b3ebb03bb44.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/57-bd880478516a225297ea.min.js